export const transitionStyles = {
    entering: { opacity: 0 },
    entered: {
        opacity: 1,
        transition: 'opacity 300ms, transform 300ms',
    },
    exited: {
        opacity: 0,
    },
};
export const transitionTimeouts = {
    appear: 0,
    enter: 300,
    exit: 100,
};
//# sourceMappingURL=incoming_call_notification_transition.js.map